export default "__VITE_ASSET__Lj9mLnnO__"